module.exports = __webpack_public_path__ + "img/come-vict-thumb.b468519a.jpg";